export default {
  sectionTitle: 'Heading.Statistics',
  labelOfJoinData: 'Label.JoinDate',
  labelOfPlaceVisits: 'Label.PlaceVisits'
};
